import React from "react";

export function PlusIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
      className={className}
    >
      <rect width="32" height="32" fill="#16161D" rx="16"></rect>
      <path
        fill="#fff"
        d="M17.365 11.22V21.8h-2.7V11.22h2.7zm3.66 4.06v2.44h-10.04v-2.44h10.04z"
      ></path>
    </svg>
  );
}
